// extracted by mini-css-extract-plugin
module.exports = {"containerZoneMessagesPanel":"ZoneMessagesPanel_containerZoneMessagesPanel__16iHM","containerNotMessages":"ZoneMessagesPanel_containerNotMessages__3z9KN"};